import { api } from '@/utils/api';

interface UseUpdateEventOptions {
    onSuccess?: (data?: unknown) => void;
    onError?: (message?: string) => void;
}

export function useUpdateEvent(options: UseUpdateEventOptions = {}) {
    const apiUtils = api.useUtils();

    const updateEventMutation = api.platoUser.command.events.update.useMutation({
        onError(error) {
            options.onError?.(error instanceof Error ? error.message : String(error));
        },
        onSuccess(_, { eventId }) {
            if (eventId) {
                apiUtils.platoUser.query.events.getEventById.invalidate({ eventId });
            }
            apiUtils.platoUser.query.customerActivity.getFeedList.withFilters.invalidate();
            apiUtils.platoUser.query.events.getList.invalidate();
            apiUtils.platoUser.query.events.getUpcomingCustomerEvents.invalidate();
            options.onSuccess?.();
        },
    });

    return updateEventMutation;
}
